import { css, styled } from "styled-components";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import {
  Product,
  ProductAttributeWithOptions,
} from "@ludens-reklame/rubics-v3-sdk/product/types";

interface Props {
  product: Product;
  attribute: ProductAttributeWithOptions;
}

export const Attribute: React.FC<Props> = ({ attribute, product }) => {
  function currentValue() {
    if (attribute.type === "size") {
      return (
        <Value $active>
          <ValueLabel className="h6" $standalone>
            {attribute.value}
          </ValueLabel>
        </Value>
      );
    }

    return (
      <>
        <Value $active>
          {product.primaryImage && (
            <img
              src={transformImageUrl(product.primaryImage, {
                width: 200,
                height: 200,
                fit: "cover",
              })}
              alt={product.primaryImage.altText}
              width={100}
              height={100}
            />
          )}
        </Value>
        <ValueLabel className="h6">{attribute.value}</ValueLabel>
      </>
    );
  }

  return (
    <Wrapper>
      <p className="h6">{attribute.name}</p>
      <ul>
        <li>{currentValue()}</li>
        {attribute.options.map((o) => {
          if (attribute.type === "size") {
            return (
              <li key={o.value}>
                <Value href={o.product.url}>
                  <ValueLabel className="h6" $standalone>
                    {o.value}
                  </ValueLabel>
                </Value>
              </li>
            );
          }

          return (
            <li key={o.value}>
              <Value href={o.product.url}>
                {o.product.image && (
                  <img
                    src={transformImageUrl(o.product.image, {
                      width: 200,
                      height: 200,
                      fit: "cover",
                    })}
                    alt={o.product.image.altText}
                    width={100}
                    height={100}
                  />
                )}
              </Value>
              <ValueLabel className="h6">{o.value}</ValueLabel>
            </li>
          );
        })}
      </ul>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  max-width: 472px;

  ul {
    list-style: none;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-gap: ${(props) => props.theme.spacing.m};
    margin: 0;
    padding: 0;
  }
`;

const Value = styled.a<{ $active?: boolean }>`
  display: block;
  border: 1px solid
    ${(props) => (props.$active ? "var(--swatch2)" : "rgba(0, 0, 0, 0.12)")};
  border-radius: 10px;
  color: inherit;
  text-decoration: none;

  img {
    display: block;
    width: 100%;
    height: auto;
    aspect-ratio: 1;
    border-radius: 10px;
  }
`;

const ValueLabel = styled.p<{ $standalone?: boolean }>`
  margin: ${(props) => props.theme.spacing.xs} 0 0 !important;
  text-align: center;

  ${(props) =>
    props.$standalone &&
    css`
      margin: ${(props) => props.theme.spacing.xs} 0 !important;
    `}
`;
